/*
  *****************************************************
  My scan success page logic
  Page: /pages/scan-success
  ******************************************************
*/
const scanSuccessPageInit = async (id, flow) => {
  const {
    proxyUrl
  } = window.assetUrls;

  try {

    const [proxyModule] = await Promise.all([
      import(proxyUrl)
    ]);

    const { getCustomerScan, getGuestScan } = proxyModule;

    const classes = {
      scancontent: ".image-with-text__content.scan-success",
      wrapper: ".my-scan",
      frame: ".my-scan__scan-frame",
      container: ".container-scan-success",
      loader: ".lds-my-scan-wrapper",
      loaderHidden: "lds-my-scan-wrapper--hidden",
      loadingclass: "scan-loading",
      hidden: "hidden"
    }

    const iframe = document.querySelector(classes.frame);
    const container = document.querySelector(classes.container);
    const scanContainer = document.querySelector(classes.scancontent);

    let lastVersion = undefined;

    container.classList.remove('hidden');

    if(!iframe) return;

    const loader = document.querySelector(classes.loader);
    let hasNoScan;
    let timeoutId;
    let data;

    const pollingFunction = async () => {

      if(flow === 'customer'){
          data = await getCustomerScan(id);
      } else {
          data = await getGuestScan(id);
      }
      if(data) {

        let route;
        let version;
        let status = data.status;

        route = data.route;
        version = data.version;

        const messages = document.querySelectorAll("[data-scan-in-progress]");
        
        
          if(status != "INPROGRESS" && route){
            messages.forEach(message => {
              message.classList.remove("my-scan__in-progress-message--active");
              lastVersion = version;
              loader.classList.add(classes.loaderHidden);
              container.classList.remove(classes.loadingclass);
              scanContainer.classList.remove(classes.hidden);
              message.classList.add("hidden");
              const iframeLink = `${window.vto_widget_url}/${route}?hint=false&slideFull=true`; 
              iframe.setAttribute("src", iframeLink);
          
             })
            if(timeoutId) {
              clearTimeout(timeoutId);
            }
          }else{
             messages.forEach(message => {
              message.classList.add("my-scan__in-progress-message--active");
              message.classList.remove("hidden");
             })
           setTimeout(pollingFunction, 2000);
          }
       

      }
    }

    pollingFunction();
  } catch (error) {
    console.error("Failed to initialize Scan Success page:", error);
  }
}


async function updateScanFromQuery() {

  const { vtoUtilsUrl, proxyUrl} = window.assetUrls;
  const [utilsModule,proxyModule] = await Promise.all([
      import(vtoUtilsUrl),
      import(proxyUrl)
  ]);

  const { updateStorage } = utilsModule;
  const { verifyGuestScan } = proxyModule;

  const customerId = window['customerInfo']['id'];
  if(customerId){
    scanSuccessPageInit(customerId, 'customer');
  } else {
      // Parse URL parameters
      const guestScanKey = 'guest_scan'; // Key for session storage
      const urlParams = new URLSearchParams(window.location.search);
      const newGuestId = urlParams.get('guestId');
      if(newGuestId) {
        const { guestId, expiration} = await verifyGuestScan(newGuestId);
        updateStorage (guestScanKey, { id: newGuestId, has_scan: false, expiration: expiration })
        document.querySelector(".vto-login-button.guest_user").classList.remove("hidden");
        scanSuccessPageInit(newGuestId,'guest_scan');
      } else {
        const scancontent = document.querySelector(".image-with-text__content.scan-success");
        scancontent.classList.remove("hidden");
        document.querySelector(".vto-login-button.from_login").classList.remove("hidden");
        document.querySelector(".hide-customer").classList.add("hidden");
        document.querySelector(".section-blocks__buttons-wrapper .btn--callout").classList.add("hidden");
        
      }

  }
}

// Call the function on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    updateScanFromQuery().catch(error => {
      console.error('Error updating scan:', error);
    });
  });
} else {
  // DOM already loaded
  console.log('Document already loaded, updating guest scan...');
  updateScanFromQuery().catch(error => {
    console.error('Error updating scan:', error);
  });
}
